import { render, staticRenderFns } from "./OvertimeRecentUpdates.vue?vue&type=template&id=cc6fd2f6"
import script from "./OvertimeRecentUpdates.vue?vue&type=script&lang=js"
export * from "./OvertimeRecentUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports